import { render, staticRenderFns } from "./ShareWidget.vue?vue&type=template&id=76b19b50&"
import script from "./ShareWidget.vue?vue&type=script&lang=js&"
export * from "./ShareWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShareWidget.vue?vue&type=style&index=0&id=76b19b50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports